import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=0877ff56&"
import script from "./LoginView.vue?vue&type=script&lang=ts&"
export * from "./LoginView.vue?vue&type=script&lang=ts&"
import style0 from "./LoginView.vue?vue&type=style&index=0&id=0877ff56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports